import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import { IAssessment, AssessmentForm } from '@/entities';
import { RootState } from '@/store/types';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

Vue.use(Vuex);
// const temp = require('./dd_assessment_template_en.json');

const data = {
    usedTemplate: undefined,
    reviewerId: undefined,
    applicationId: undefined,
    _id: undefined,
    version: undefined,
    status: undefined,
    assessment: {},
    selectedKey: "organizationinformation"
};

export const state: IAssessment = new AssessmentForm(data);
const namespaced: boolean = true;

export const assessmentForm: Module<IAssessment, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations
}